import { render, staticRenderFns } from "./form-script-ad.vue?vue&type=template&id=620ced66&"
import script from "./form-script-ad.vue?vue&type=script&lang=js&"
export * from "./form-script-ad.vue?vue&type=script&lang=js&"
import style0 from "./form-script-ad.vue?vue&type=style&index=0&id=620ced66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports